import { Box, Container, GridItem, SimpleGrid } from '@chakra-ui/react';
import { GetServerSidePropsContext, GetServerSidePropsResult, NextPage } from 'next';

import { withCommonServerSideProps } from '@/lib/withCommonServerSideProps';

import ArticleContent from '@/components/Article/articleContent';
import { H1 } from '@/components/Heading';
import Seo from '@/components/Seo';

import { MonthAction } from '@/models/cms/MonthAction';
import { LocaleProps } from '@/models/props/LocalizationProps';
import { MonthActionsService } from '@/services/MonthActionsService';

type MonthActionPageProps = {
    item: MonthAction;
};

export const MonthActionPage: NextPage<MonthActionPageProps> = ({ item }) => {
    return (
        <>
            <Seo title={item?.attributes?.title} />
            <Container maxW="container.xl" paddingY={10}>
                <Box textAlign="center" mb="14">
                    <H1 mb={0}>{item?.attributes?.title}</H1>
                </Box>
                <SimpleGrid columns={{ xl: 6 }} spacing={{ xl: 7 }}>
                    <GridItem />
                    <GridItem colSpan={{ xl: 4 }}>
                        <ArticleContent content={item.attributes.content} styles={{ pl: 0 }} />
                    </GridItem>
                </SimpleGrid>
            </Container>
        </>
    );
};

export const getServerSideProps = withCommonServerSideProps(
    async (
        context: GetServerSidePropsContext
    ): Promise<GetServerSidePropsResult<MonthActionPageProps>> => {
        const { query, locale } = context;
        const slug = query.slug as string;
        const item = await MonthActionsService.getMonthAction(slug, locale as LocaleProps).then(
            (response) => response.data.data[0]
        );

        if (!item) {
            return {
                notFound: true
            };
        }

        return {
            props: {
                item
            }
        };
    }
);

export default MonthActionPage;
